import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    Output
} from '@angular/core';
import { PaymentStepsService } from '../services/payment-steps.service';
import { PaymentMethodModel } from '../../shared/models/payment-method.model';
import { isNull } from 'util';
import { DeliveryStepsService } from '../services/delivery-steps.service';
import { ResumeUpdaterService } from '../../cart/services/cart-resume-updater.service';
import { AuthenticatedUserRepositoryService } from '../services/authenticated-user-repository.service';

@Component({
    selector: 'payment-payment',
    templateUrl: './payment.payment.component.html',
    styleUrls: ['./../payment.component.scss']
})
export class PaymentPaymentComponent implements AfterViewInit {
    public loading = false;
    public filled = false;
    public paymentMethods: Array<PaymentMethodModel> = [];
    public selectedPaymentMethod: PaymentMethodModel = null;
    @Input() deliveryReady: boolean;
    @Input() deliverable: boolean;
    @Output() ready: EventEmitter<null> = new EventEmitter();
    @Output() activated: EventEmitter<null> = new EventEmitter();
    @Output() pending: EventEmitter<null> = new EventEmitter();

    constructor(
        protected paymentStepsService: PaymentStepsService,
        protected deliveryStepsService: DeliveryStepsService,
        protected resumeUpdaterService: ResumeUpdaterService,
        protected authenticatedUserService: AuthenticatedUserRepositoryService
    ) {
        this.deliveryStepsService.selectedFreight$.subscribe(() => {
            this.loadPaymentMethodsOptions();
        });
        this.paymentStepsService.loadedPaymentMethods$.subscribe(() => {
            this.paymentMethods = this.paymentStepsService.getPaymentMethods();
        });
        this.resumeUpdaterService.validatedCoupon$.subscribe(() => {
            if (null !== this.authenticatedUserService.getUser()) {
                this.loadPaymentMethodsOptions();
            }
        });
        this.authenticatedUserService.changedUser$.subscribe(user => {
            if (user !== null && !this.deliverable) {
                this.loadPaymentMethodsOptions();
            }
        });
        this.authenticatedUserService.resetedUser$.subscribe(() => {
            this.paymentMethods = [];
            this.selectedPaymentMethod = null;
            this.resumeUpdaterService
                .clearPaymentMethodDiscount()
                .subscribe();
            this.paymentStepsService
                .setSelectedPaymentMethod(null);
        });
    }

    ngAfterViewInit() {
        if (!this.deliverable && this.deliveryReady) {
            this.loadPaymentMethodsOptions();
        }
    }

    /** Calling payment steps service to load payment methods options */
    private loadPaymentMethodsOptions() {
        this.paymentStepsService.loadPaymentMethods().subscribe();
    }

    /**
     * Returns true if has some value at selectedPaymentMethod property.
     **/
    public hasSelectedPaymentMethod(): boolean {
        return !isNull(this.selectedPaymentMethod);
    }
    /**
     * childActivated event listener. Emits activated output.
     **/
    public onChildActivated() {
        this.activated.emit();
    }
    /**
     * childPending event listener. Emits pending output.
     **/
    public onChildPending() {
        this.pending.emit();
    }
    /**
     * changedPaymentMethod event listener.
     **/
    public onChangedPaymentMethod(paymentMethod: PaymentMethodModel) {
        this.selectedPaymentMethod = paymentMethod;
        this.resumeUpdaterService
            .updateBySelectedPaymentMethod(paymentMethod)
            .subscribe();
        this.paymentStepsService
            .setSelectedPaymentMethod(paymentMethod);
    }
    /**
     * filled event listener. Trigger ready output event.
     **/
    public onFilled() {
        this.filled = true;
        this.ready.emit();
    }
    /**
     * filled event listener. Trigger ready output event.
     **/
    public onUnfilled() {
        this.filled = false;
        this.activated.emit();
    }
    /**
     * Check if paymentmethod option must be checked.
     **/
    public isChecked(paymentMethod: PaymentMethodModel) {
        return this.hasSelectedPaymentMethod() &&
            this.selectedPaymentMethod.id === paymentMethod.id;
    }
    /**
     * Build class to represents payment method type.
     **/
    public buildPaymentMethodTypeClass(paymentMethod: PaymentMethodModel) {
        return paymentMethod.type.replace(/ /g, '-');
    }

    get isApplyingFreight(): boolean {
	  return this.deliveryStepsService.isApplyingFreight;
	}
}



// WEBPACK FOOTER //
// /codebuild/output/src3894461559/src/src/app/payment/payment/payment.payment.component.ts